module.exports = __webpack_public_path__ + "img/en.bc28cc7d.png";